<template>
    <div>
		<div class="bg-grey-lighter w-full h-screen font-sans">
			<div class="container mx-auto h-full flex justify-center items-center">
				<div class="w-1/3">
					<div>
						<h1 class="font-light mb-3 text-center">UtskriftsAppen</h1>
						<h3 class="font-light mb-6 text-center text-red">Felmeddelande 500</h3>
						<div class="border-green p-8 border-t-4 bg-white mb-6 rounded-lg shadow-lg">
							<p>
								En buggrapport har skickats iväg.<br>
								Vi lovar att titta på problemet så snart vi bara kan!<br><br> 
								Under tiden kan du hoppa tillbaka <a href="/">till startsidan</a>.
							</p>
						</div>
					</div>
				</div>
			</div>
        </div>
    </div>
</template>

<script>
    export default {

    }   
</script>